import React from "react"
import parse from "html-react-parser"
import { useStaticQuery, graphql } from "gatsby"
import CurveTSm from "./icons/curve-t-sm"
import Location from "./icons/location"
import Html from "./html"

export default function Content({ props, translations }) {
  const data = useStaticQuery(graphql`
    query {
      allWpRegion {
        nodes {
          name
          locations {
            nodes {
              menuOrder
              title
              location {
                address
                phone
              }
            }
          }
        }
      }
    }
  `)
  const heading = translations?.heading || props.heading
  const regions = data?.allWpRegion?.nodes

  return (
    <section
      className={`bg-blue-50 relative mt-12`}
      key={`locations ${heading}`}
    >
      <CurveTSm
        className={`w-full absolute -translate-y-full top-[1px] z-10 text-blue-50`}
      />

      <div className={`container pb-12 pt-6 divide-y divide-blue-200`}>
        {heading && (
          <h2
            className="mb-8 text-center"
            data-sal="slide-up"
            data-sal-easing="ease"
          >
            {parse(heading)}
          </h2>
        )}
        {regions ? (
          <div className="sm:pt-6">
            <ul className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 divide-y sm:divide-y-0 md:divide-x divide-blue-200 sm:-mx-6 lg:-mx-10 xl:-mx-12 2xl:-mx-22">
              {regions?.map(region => {
                const locations = region.locations?.nodes?.sort((a, b) => {
                  return a.menuOrder - b.menuOrder
                })
                return (
                  <>
                    {locations ? (
                      <li
                        className="sm:px-8 lg:px-12 xl:px-14 2xl:px-24 py-6 sm:py-0 sm:my-6"
                        key={region.name}
                      >
                        <h3 className="font-bold mb-4 h3">{region.name}</h3>
                        <ul>
                          {locations.map(location => {
                            const { address, phone } = location.location
                            return (
                              <li
                                className="flex items-start mb-8"
                                key={location.title}
                              >
                                <Location className="text-magenta w-6 inline-block mr-2 flex-shrink-0 flex-grow-0" />
                                <div className="leading-snug">
                                  <h4 className="mb-1">{location.title}</h4>
                                  {address ? (
                                    <a
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      href={`https://www.google.com/maps/place/${encodeURI(
                                        address
                                          .replaceAll("#", "")
                                          .replaceAll("<br />", " ")
                                      )}`}
                                      itemProp="address"
                                      className="block text-black"
                                    >
                                      <Html
                                        className="mb-1 leading-snug">
                                        {address}
                                      </Html>
                                    </a>
                                  ) : null}
                                  {phone ? (
                                    <a
                                      href={`tel:+1${phone}`}
                                      className="mb-1 leading-snug text-black"
                                    >
                                      {phone}
                                    </a>
                                  ) : null}
                                </div>
                              </li>
                            )
                          })}
                        </ul>
                      </li>
                    ) : null}
                  </>
                )
              })}
            </ul>
          </div>
        ) : null}
      </div>
    </section>
  )
}
